import { render, staticRenderFns } from "./VProducts.vue?vue&type=template&id=39984641&scoped=true"
import script from "./VProducts.vue?vue&type=script&lang=ts"
export * from "./VProducts.vue?vue&type=script&lang=ts"
import style0 from "./VProducts.vue?vue&type=style&index=0&id=39984641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39984641",
  null
  
)

export default component.exports